// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3rO8H","overflowing":"ReadFullNote_overflowing__26lG2"};